import styled from '@emotion/styled'
import { css } from '@emotion/react'

const wrapperStyles = ({ theme }) => css`
  label: sidebar;

  width: 100%;
  background: ${theme.colors.white};
  overflow: hidden;
`

const navStyles = ({ theme }) => css`
  label: sidebar__nav;

  padding: ${theme.spacings.mega} ${theme.spacings.kilo} 0;
`

const contentTitleStyles = ({ theme }) => css`
  label: sidebar__content-title;

  font-weight: ${theme.font.weight.semibold};
  color: ${theme.colors.n600};

  font-size: ${theme.typography.subHeadings.mega.fontSize};
  margin-bottom: ${theme.spacings.mega};
`

const headerStyles = ({ theme }) => css`
  label: header;

  display: flex;
  align-items: center;

  padding: ${theme.spacings.mega} ${theme.spacings.kilo} ${theme.spacings.mega};
  border-bottom: 1px solid ${theme.colors.n100};
`

const userAvatarStyles = ({ theme, isOnLoyalty }) => css`
  label: header__user-avatar;

  display: flex;
  border: 2px solid ${isOnLoyalty ? theme.colors.f500 : 'transparent'};
  width: 48px;

  flex-basis: ${theme.spacings.exa};
  border-radius: ${theme.borderRadius.circle};
`

const userPhotoStyles = ({ theme }) => css`
  label: header__user-photo;

  display: flex;
  align-items: center;
  justify-content: center;

  border: 3px solid ${theme.colors.white};
  border-radius: ${theme.borderRadius.circle};
  padding-left: 1px;
  padding-bottom: 1px;
  background-color: ${theme.colors.n300};

  width: 44px;
  height: 44px;
  text-transform: uppercase;
  color: ${theme.colors.n500};
  font-size: ${theme.typography.text.giga.fontSize};
  line-height: ${theme.typography.text.giga.lineHeight};
`

const userNameStyles = ({ theme }) => css`
  label: header__username;

  color: ${theme.colors.n400};
  font-size: ${theme.typography.subHeadings.mega.fontSize};
  line-height: ${theme.typography.subHeadings.mega.lineHeight};

  margin-left: ${theme.spacings.kilo};

  div {
    font-weight: ${theme.font.weight.semibold};
  }
`

export const Wrapper = styled('div')(wrapperStyles)
export const Nav = styled('nav')(navStyles)
export const ContentTitle = styled('h2')(contentTitleStyles)
export const Header = styled('div')(headerStyles)
export const UserAvatar = styled('picture')(userAvatarStyles)
export const UserPhoto = styled('div')(userPhotoStyles)
export const UserName = styled('span')(userNameStyles)
